import "antd/dist/reset.css";
import { Collapse, Empty, message } from "antd";
import React from "react";
import utils from "utils";
import "./SOSSummaryChild.scss";
import api from "utils/api";
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
const { Panel } = Collapse;


class CareTeam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            result: {},
            isLoading: false,
        }
    }
    componentDidMount() {
        this.getConsultedCareTeam();
    }

    getConsultedCareTeam() {
        this.setState({ isLoading: true });
        let data = {
            patient_id: this.props.data?.patient_id,
        }
        api
            .get_consulted_doctors(data)
            .then((res) => {
                if (res.data?.status == 200) {
                    this.setState({ result: res.data, isLoading: false, });
                } else {
                    message.error(res.data?.message, ErrorDuration);
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => { this.setState({ isLoading: false }) });
    }
    render() {
        return (
            <>
                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <div className="mhe-wrapper-container">
                        <div className="consultedDoc-careteam">
                            <div>{CONSTANTS.CONSULTED_DOCTORS}</div>
                        </div>

            <div className="mhe-content">
              {this.state?.result?.data?.count == 0 ? (
                <Empty
                  description={"No Data"}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ) : (
                <div className="Consulted-doc-collapse">
                  <div className="consultedCilinician-patient">
                    {CONSTANTS.CONSULTED_CLINICIAN}
                    {utils.FirstNameLastName(
                      utils.getDisplayName(
                        this.props?.data?.patient_name,
                        this.props?.data?.patient_last_name
                      ),
                      "250px"
                    )}
                  </div>
                  {this.state?.result?.data?.results.map((data, i) => {
                    return (
                      <div className="careteam-conulted-modal">
                        <div className="careteam-list">
                          <div>
                            <span className="doc-name-CareTeam">
                              {utils.FirstNameLastName(
                                utils.salutationPrefixName(
                                  data?.doctor_detail?.salutation,
                                  utils.getDisplayName(
                                    data?.doctor_detail?.doctor_name,
                                    data?.doctor_detail?.doctor_last_name
                                  )
                                ),
                                "300px"
                              )}
                            </span>
                            <span className="doc-speciality">
                              {utils.FirstNameLastName(
                                data?.doctor_detail?.doctor_speciality.join(
                                  ", "
                                ),
                                "300px"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="careTeam-lastConsulted-heading">
                          <div className="lastConsulted-withdate">
                          <div className="allPatients-lastConsulted">
                            {CONSTANTS.LAST_CONSULTED_ON}
                          </div>
                          <span className="date-last-consulted-heading">
                            <div>
                              {utils.FormatDate(
                                data?.appointment_list[0]?.appointment_date_time,
                                "DATE_14"
                              )}
                            </div>
                            <div>
                              {utils.FormatDate(
                                data?.appointment_list[0]?.appointment_date_time,
                                "TIME_1"
                              )}
                            </div>
                          </span>
                          </div>
                          <ul className="zeroEncounter-list">
                            {
                            data?.appointment_list[0]?.is_zero_encounter ? 
                            <li className="zeroencounter-allPatients">
                              {CONSTANTS.ZERO_ENCOUNTER} - {data?.appointment_list[0]?.mode_of_communication}
                            </li>:
                            <li className="zeroencounter-allPatients">
                              {/* {CONSTANTS.VIDEO_CALL} */}
                              {data?.appointment_list[0]?.mode_of_communication}
                            </li>
                            }
                          </ul>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
    }
};

export default CareTeam;
